import React, { useContext } from 'react';
import { WishlistContext } from '..';

const Intro = ({ showButtons = true }) => {
  const {
    showShareWithAFriend,
    setShowShareWithAFriend,
    showShareWithUs,
    setShowShareWithUs,
    intro,
  } = useContext(WishlistContext);

  const { title, text, 'tailor-made': tailorMade } = intro;

  return (
    <div className="c-intro">
      <div className="c-intro__content">
        <div className="c-intro__content__text">
          <h1 className="c-intro__content__text__title o-after-line o-after-line--purple">
            {title}
          </h1>

          <div
            className="o-text"
            dangerouslySetInnerHTML={{ __html: text }}
          ></div>
        </div>
        {showButtons && (
          <div className="c-wishlist__intro-buttons">
            <button
              className="o-btn o-btn--outline o-btn--purple"
              onClick={() => setShowShareWithAFriend(!showShareWithAFriend)}
            >
              Share with a Friend
            </button>

            <button
              className="o-btn o-btn--purple"
              onClick={() => setShowShareWithUs(!showShareWithUs)}
            >
              Share with us
            </button>
          </div>
        )}
      </div>

      <div className="c-intro__sidebar ">
        <div className="c-intro__sidebar__tm">
          <h3 className="c-intro__sidebar__tm__title">{tailorMade.title}</h3>

          <p
            className="o-text"
            dangerouslySetInnerHTML={{ __html: tailorMade.text }}
          ></p>

          <a
            href={tailorMade.link.url}
            className="o-btn"
            title={tailorMade.link.title}
          >
            {tailorMade.link.title}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Intro;
